
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14 10a4 4 0 00-4 4v11.172l4.586-4.586.027-.027c1.229-1.182 2.742-1.899 4.387-1.899 1.645 0 3.159.717 4.387 1.899l.027.027L28 25.172l.586-.586.027-.027c1.472-1.416 3.342-2.148 5.307-1.822a2 2 0 01-.656 3.946c-.488-.081-1.13.045-1.865.746l-1.985 1.985a2 2 0 01-2.828 0L20.6 23.43c-.623-.594-1.177-.768-1.601-.768-.424 0-.978.174-1.6.768l-7.4 7.4V34a4 4 0 004 4h10a2 2 0 110 4H14a8 8 0 01-8-8V14a8 8 0 018-8h20a8 8 0 018 8v10a2 2 0 11-4 0V14a4 4 0 00-4-4H14zm14 6a2 2 0 012-2h.02a2 2 0 110 4H30a2 2 0 01-2-2zm10 18a4 4 0 00-3.864 5.036l4.9-4.9A4.005 4.005 0 0038 34zm3.864 2.964l-4.9 4.9a4.005 4.005 0 004.9-4.9zM30 38a8 8 0 1116 0 8 8 0 01-16 0z"}})])
          )
        }
      }
    